export enum PayoutStatusEnum {
  PAID = 'PAID',
  PENDING = 'PENDING',
  IN_TRANSIT = 'IN_TRANSIT',
  FAILED = 'FAILED',
  CANCELED = 'CANCELED',
}
